import React, { useState, useEffect } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import { useTranslation } from 'react-i18next';

import Landing from "./sites/Landing";
import Home from "./sites/Home";
import Projects from "./sites/Projects";
import Blog from "./sites/Blog";
import BlogPost from "./sites/BlogPost";
import Login from "./sites/Login.js";
import Dashboard from "./sites/Dashboard.js";
import BlogWriting from "./sites/BlogWriting.js";

import Navigation from "./components/Navigation";
import FooterMarquee from "./components/FooterMarquee.js";

function App() {
  const { ready } = useTranslation();
  const location = useLocation();
  const isLanding = location.pathname === "/";

  // Scroll to top when location changes, but not when contact scroll is pending
  useEffect(() => {
    const shouldScrollToContact = sessionStorage.getItem('scrollToContact');
    if (!shouldScrollToContact) {
      // Use requestAnimationFrame to ensure DOM is ready
      requestAnimationFrame(() => {
        window.scrollTo(0, 0);
      });
    }
  }, [location.pathname]);

  // Don't render anything until i18n is ready
  if (!ready) {
    return <div>Loading...</div>;
  }

  // Hide Navigation and Footer on Landing and Login pages
  const hideNavFooter = isLanding || location.pathname === "/login";

  return (
    <div className="app-wrapper position-relative">
      {/* Grid background */}
      <div className="grid-background" aria-hidden="true"></div>

      {!hideNavFooter && <Navigation />}

      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/home" element={<Home />} />
        <Route path="/projects" element={<Projects />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/BlogPost/:id" element={<BlogPost />} />
        <Route path="/login" element={<Login />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/BlogWriting" element={<BlogWriting />} />
        <Route path="/BlogWriting/:id" element={<BlogWriting />} />
      </Routes>

      {!hideNavFooter && <FooterMarquee />}
    </div>
  );
}

export default App;
